<script lang="ts">
  import type { Snippet } from "svelte";
  import { getFieldContext } from "./context";

  let {
    value,
    badge,
    children
  } : {
    value: string;
    badge?: string;
    children: Snippet;
  } = $props()

  const context = getFieldContext()
</script>
<div class="ui-option-container relative">
  {#if badge}
    <div class="absolute -top-3 text-sm font-medium text-emerald-700 bg-emerald-100 py-[0.1250rem] px-2 rounded-badge">{badge}</div>
  {/if}
  <label class={[
    "flex flex-row gap-2 items-start",
    badge && "mt-3"
  ]}>
    <input
      type="radio"
      name={context.field.name}
      {value}
      class="radio"
      bind:group={context.field.value}
      required={context.required} />
    <div>
      {@render children()}
    </div>
  </label>
</div>
